const funcs = {
    injectJSFile: function(iframeDoc, path) {
        var iframeHead = iframeDoc.getElementsByTagName("head")[0];         
        var myscript = document.createElement('script');
        myscript.type = 'text/javascript';
        myscript.src = path;
        iframeHead.appendChild(myscript);
    },
    injectCSSFile: function(iframeDoc, path) {
        var iframeBody = iframeDoc.getElementsByTagName("body")[0];         
        var cssLink = document.createElement('link');
        cssLink.type = 'text/css';
        cssLink.href = path;
        cssLink.rel = "stylesheet"; 
        iframeBody.appendChild(cssLink);
    },
}

export default funcs